import React from 'react'
import { Link, NavLink } from 'react-router-dom'

const Navbar = () => {

    const data = {
        logo: {
            title: 'AM',
            link: '/'
        },
        links: [
            {title: 'Tools', link: '/#tools'}
        ]
    }

  return (
    <>

        <header className="flex flex-wrap  md:justify-start md:flex-nowrap z-50 w-full bg-white border-b border-gray-200">
            <nav className="relative max-w-[85rem] w-full mx-auto md:flex md:items-center md:justify-between md:gap-3 py-2 px-4 sm:px-6 lg:px-8">

                <div className="flex justify-between items-center gap-x-1">
                    <Link to={data.logo.link} className="flex-none font-semibold text-xl text-black focus:outline-hidden focus:opacity-80">
                        {data.logo.title}
                    </Link>

                    <button type="button" className="hs-collapse-toggle md:hidden relative size-9 flex justify-center items-center font-medium text-sm rounded-lg border border-gray-200 text-gray-800 hover:bg-gray-100 focus:outline-hidden focus:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none" id="hs-header-base-collapse"  aria-expanded="false" aria-controls="hs-header-base" aria-label="Toggle navigation"  data-hs-collapse="#hs-header-base" >
                        <svg className="hs-collapse-open:hidden size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="3" x2="21" y1="6" y2="6"/><line x1="3" x2="21" y1="12" y2="12"/><line x1="3" x2="21" y1="18" y2="18"/></svg>
                        <svg className="hs-collapse-open:block shrink-0 hidden size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>                        
                        <span className="sr-only">Toggle navigation</span>
                    </button>
                </div>

                <div id="hs-header-base" className="hs-collapse hidden overflow-hidden transition-all duration-300 basis-full grow md:block "  aria-labelledby="hs-header-base-collapse" >
                    <div className="overflow-hidden overflow-y-auto max-h-[75vh] [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-track]:bg-gray-100 [&::-webkit-scrollbar-thumb]:bg-gray-300">
                        <div className="py-2 md:py-0  flex flex-col md:flex-row md:items-center gap-0.5 md:gap-1">

                            <div className="grow">
                                <div className="flex flex-col md:flex-row md:justify-end md:items-center gap-0.5 md:gap-1">

                                    {data.links.map( (link, index) => {return (
                                        <NavLink to={link.link} key={index} className="p-2 flex items-center text-sm text-gray-800 hover:bg-gray-100 rounded-lg focus:outline-hidden focus:bg-gray-100">
                                            {link.title}
                                        </NavLink>
                                    )})}

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </nav>
        </header>

    </>
  )
}

export default Navbar